import { Component, Host, Prop, h } from '@stencil/core';
import { syQuerySelector } from '../../../../utils/dom.utils';
@Component({
  tag: 'sy-blog-summary-node',
  styleUrl: 'sy-blog-summary-node.scss',
  scoped: true,
})
export class SyBlogSummaryNode {
  /**
   * Sets the title for the summary section.
   */
  @Prop() sectionTitle = '';

  /**
   * Indicates the depth level of the node in the tree. The first level is 0.
   */
  @Prop() level: number;

  /**
   * Defines the offset from the top when scrolling to this node.
   * Default value is 53.
   */
  @Prop() scrollOffset = 53;

  private sectionId = '';

  /**
   * Scrolls to the associated section when clicked.
   */
  private scrollToNavigation(e: Event): void {
    e.preventDefault();
    const section = syQuerySelector(`#${this.sectionId}`) as HTMLElement;

    // Calculate the scroll position and scroll smoothly to it
    window.scrollTo({
      top: section.getBoundingClientRect().top + window.scrollY - this.scrollOffset,
      behavior: 'smooth',
    });
  }

  /**
   * Converts a string to kebab case.
   * @param str The input string.
   */
  private kebabCase(str: string): string | undefined {
    const c = str
      .normalize('NFD')
      ?.replace(/[\u0300-\u036f]/g, '')
      ?.toLowerCase();
    return c
      ?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      ?.map((x: string) => x.toLowerCase())
      .join('-');
  }

  componentWillLoad() {
    // Generate a unique section ID based on the section title in kebab case
    this.sectionId = `section-${this.kebabCase(this.sectionTitle)}`;
  }

  render() {
    // Create a URL with a hash that links to the section
    const url = new URL(window.location.href);
    url.hash = this.sectionId;

    return (
      <Host style={{ '--sy-blog-summary-level': this.level.toString() }} onClick={(e) => this.scrollToNavigation(e)}>
        <sy-text>
          <a href={url.href} innerHTML={this.sectionTitle}></a>
        </sy-text>
      </Host>
    );
  }
}
